import { Component, OnInit, NgZone, ViewChild, ViewContainerRef, ComponentFactoryResolver, ElementRef } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { Ng2Datetime } from 'ng2-datetime-picker';
import { ExtraService } from '../../core/services/extra.service';
import { SessionService } from '../../core/services/session.service';
import { SessionTopicService } from '../../core/services/session-topic.service';
import { MapsAPILoader } from '@agm/core';
//import { } from 'googlemaps';
import { SpeakerService } from '../../core/services/speaker.service';
import * as firebase from 'firebase';
import { Session } from '../../core/models/session';
import { SessionTopic } from '../../core/models/session-topic';

import { Speaker } from '../../core/models/speaker';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { FileUpload } from '../../core/models/fileupload';
import { ContentsMandatory } from '../../core/models/contents-mandatory';
import { MenuTypeService } from '../../core/services/menu-type.service';
import { EventPreferences } from '../../core/models/event-preferences';
import { error } from 'selenium-webdriver';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { HeaderImageSliderComponent } from '../../layout/header-image-slider/header-image-slider.component';
import { c } from '@angular/core/src/render3';

@Component({
	selector: 'app-sessions-topic',
	templateUrl: './sessions-topic.component.html',
	styleUrls: ['./sessions-topic.component.css'],
	providers: [DragulaService, SessionService, SpeakerService, DatePipe, ExtraService, NewPageService, MenuTypeService]
})
export class SessionsTopicComponent implements OnInit {

	minDate = new Date();

	@ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;
	@ViewChild('template', { read: ViewContainerRef }) template: ViewContainerRef;
	@ViewChild("search")

	public searchElementRef: ElementRef;

	file_error_summary = Constants.VIDEO_SIZE_ERROR_MESSAGE_SUMMARY;
	file_error_detail = Constants.VIDEO_SIZE_ERROR_MESSAGE_DETAIL;
	file_size = Constants.VIDEO_SIZE;
	LABEL_SHORT_VENUE_DESCRIPTION = Constants.LABEL_SHORT_VENUE_DESCRIPTION;

	pageTitle: string = 'Add Sessions';
	pageAlias: string = 'sessions-form';

	disableButton: boolean = true;
	nameClass = 'form-control';
	startTimeClass = 'dateIcon';
	endTimeClass = 'dateIcon';
	locationClass = 'form-control';
	descClass = 'form-control';
	backgroundClass = 'description-bg';
	isChecked: boolean = false;
	dywadscreen: boolean = false;
	sectionName: boolean = false;
	eventLists: boolean = true;
	chairpersonList: boolean = true;
	prop2: string;

	lat: number;
	long: number;
	latitude: number;
	longitude: number;
	showVenueTab: boolean;

	locationShort: string;
	locationAddress: string;
	public zoom: number;

	startDate: Date;
	endDate: Date;
	startTime: string = null;
	endTime: string = null;


	isError = false;
	message: string = '';
	errorMessage: string[];

	
	

	eventId: string;
	speakerId: string = null;
	speakerList = new Array<Speaker>();
	sessionList = new Array<Session>();

	sessionTopicList = new Array<SessionTopic>();

	availableSpeakerList = [];


	checkBoxSpeaker = new Array<boolean>();
	checkBoxChairPerson = new Array<boolean>();


	matchCustomLogoFileName: string;
	contentsMandatory = new ContentsMandatory();
	preferences = new EventPreferences();
	currentFileUpload: FileUpload;
	imageFile: File = null;
	progress: { percentage: number } = { percentage: 0 };

	categoryName = Constants.CONTENT_M_TYPE_SESSION;

	images: string[] = new Array();
	currentFiles = [];
	tagName = 'dragId';
	uploadprogress: number = null;
	uploadFileName: string = null;

	popupWindow = null;

	sessionTopics = [];

	log(event: boolean) {
		console.log(`Accordion has been ${event ? 'closed' : 'opened'}`);
	}

	expComponent: any;

	/** new added */
	selectSpeaker: string = 'speaker';
	selectChairPerson: string = 'chairperson';

	constructor(
		private dragula: DragulaService,
		private menuTypeService: MenuTypeService,
		private newPageService: NewPageService,
		private _cfr: ComponentFactoryResolver,
		private extraService: ExtraService,
		public datepipe: DatePipe,
		public mapsAPILoader: MapsAPILoader,
		private ngZone: NgZone, 
		private route: ActivatedRoute, 
		private router: Router,
		private sessionService: SessionService,
		private sessionTopicService: SessionTopicService,
		private speakarService: SpeakerService) {

		const bag: any = this.dragula.find(this.tagName);
		if (bag !== undefined) this.dragula.destroy(this.tagName);
		this.dragula.setOptions(this.tagName, {});
		let that = this;

		setInterval(function () {

			for (let i = 0; i < that.sessionTopics.length; i++) {

				that.topicTimeAsPerSession(i);

			}

		}, 1000);
		console.log("SessionsTopic", "Constructor")
	}

	uploadedFiles: any[] = [];
	galleryOptions: NgxGalleryOptions[];
	galleryImages: NgxGalleryImage[];


	arrayMove(array, from, to) {
		return array.splice(to, 0, array.splice(from, 1)[0]);
	}




	ngOnInit() {


		console.log("SessionsTopic", "ngOnInit");
		this.zoom = 4;


		let count = 0;
		this.extraService.castMenuTypeSubmit$.subscribe(isShow => {
			setTimeout(() => {

				this.disableButton = isShow;
				if (!this.disableButton) {
					this.message = 'File Uploading...';
				} else {
					if (count > 0) {
						this.message = 'File Uploaded Successfully';
					}
					count++;
				}
			});
		});

	

		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);


		this.route.paramMap.subscribe((params) => {
			
			let eventId = params.get('eventId');
			console.log("ParamsID",eventId);
			this.eventId = eventId;
			this.extraService.setCurrentEventId(eventId);
			this.setSessionTopicList(eventId);
			this.setSpeakerList(eventId);
		
		});

		/**
		 * No Idea why this is not working
		 */
		this.route.queryParams.subscribe(params => {

			console.log("PageParams", params);
			if (params['eventId']) {
				console.log("Event ID",  params['eventId']);
				this.eventId = params['eventId'];
				this.extraService.setCurrentEventId(params['eventId']);
				this.setSessionTopicList(params['eventId']);
				this.setSpeakerList(params['eventId']);
			}
			
		});

		// this.newPageService.up$.subscribe(data => {
		// 	if (data != null) {
		// 		let index = this.session.aboutList.indexOf(data);
		// 		if (index > 0) {
		// 			this.swap(index, index - 1);
		// 		}
		// 	}
		// });
		// this.newPageService.down$.subscribe(data => {
		// 	if (data != null) {
		// 		let index = this.session.aboutList.indexOf(data);
		// 		if (index < this.session.aboutList.length - 1) {
		// 			this.swap(index, index + 1);
		// 		}
		// 	}
		// });
		// this.newPageService.remove$.subscribe(data => {
		// 	if (data != null) {
		// 		let index = this.session.aboutList.indexOf(data);
		// 		//console.log(index);
		// 		if (index != -1) {
		// 			this.remove(index);
		// 		}
		// 	}
		// });





	}

	addSpeakerToTopic(topic_index, speaker, isChecked) {
		console.log(topic_index, speaker, isChecked);

		if (Object.keys(this.sessionTopics[topic_index]).indexOf('speakerList') == -1)
			this.sessionTopics[topic_index]['speakerList'] = [];

		if (isChecked) {
			if (this.sessionTopics[topic_index].speakerList.indexOf(speaker.key) == -1) {
				this.sessionTopics[topic_index].speakerList.push(speaker.key)
			}
		} else {



			let speaker_index = this.sessionTopics[topic_index].speakerList.indexOf(speaker.key);
			if (speaker_index != -1) {
				this.sessionTopics[topic_index].speakerList.splice(speaker_index, 1);
			}
		}

		console.log("TOPICS_", this.sessionTopics[topic_index]);
	}

	topicTimeAsPerSession(topic_index) {

		//console.log("SESSION_START_TIME", ((new Date(this.startDate).toISOString()).split("T")[0]));

		let sessionStartTimeDate = (new Date((new Date(this.startDate).toISOString()).split("T")[0] + " " + this.sessionTopics[topic_index].page.startTime));
		let sessionEndTimeDate = (new Date((new Date(this.startDate).toISOString()).split("T")[0] + " " + this.sessionTopics[topic_index].page.endTime));

		//console.log(topic_index, "START_TIME", sessionStartTimeDate);
		//console.log(topic_index, "END_TIME", sessionStartTimeDate);

		if (sessionStartTimeDate.toString() != "Invalid Date") {

			this.sessionTopics[topic_index].startTime = this.datepipe.transform(sessionStartTimeDate, Constants.DATE_TIME_FORMAT);

		}

		if (sessionEndTimeDate.toString() != "Invalid Date") {

			this.sessionTopics[topic_index].endTime = this.datepipe.transform(sessionEndTimeDate, Constants.DATE_TIME_FORMAT);

		}


	}

	moveTopic(direction, topic_index) {

		console.log(direction, topic_index);
		if (direction == 'up') {

			if (topic_index > 0) {

				// let that = this;
				// this.sessionTopics[topic_index].index = topic_index - 1;
				// let to = parseInt(topic_index) - 1;
				// let from = parseInt(topic_index);
				// this.sessionTopics.splice(to, 0, this.sessionTopics.splice(from, 1)[0]);
				let temp_details = this.sessionTopics[topic_index].page;

				this.sessionTopics[topic_index].page = this.sessionTopics[parseInt(topic_index) - 1].page;
				this.sessionTopics[parseInt(topic_index) - 1].page = temp_details;

			}

		} else {

			if (topic_index < this.sessionTopics.length) {

				// let that = this;
				// this.sessionTopics[topic_index].index = topic_index - 1;
				// let to = parseInt(topic_index) + 1;
				// let from = parseInt(topic_index);
				// this.sessionTopics.splice(to, 0, this.sessionTopics.splice(from, 1)[0]);

				let temp_details = this.sessionTopics[topic_index].page;

				this.sessionTopics[topic_index].page = this.sessionTopics[parseInt(topic_index) + 1].page;
				this.sessionTopics[parseInt(topic_index) + 1].page = temp_details;

			}

		}
	}

	

	setSearchInput() {
		setTimeout(function () {

			console.log("SearchElementRef", this.searchElementRef);
			console.log(this.mapsAPILoader);

			this.mapsAPILoader.load().then(() => {
				let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {

				});

				// To get latlong from location
				autocomplete.addListener("place_changed", () => {
					this.ngZone.run(() => {
						let place: google.maps.places.PlaceResult = autocomplete.getPlace();
						if (place.geometry === undefined || place.geometry === null) {
							return;
						}
						console.log(JSON.stringify(place));

						this.locationAddress = this.searchElementRef.nativeElement.value;
						this.lat = place.geometry.location.lat();
						this.long = place.geometry.location.lng();


						this.zoom = 12;
					});
				});
			});
		}.bind(this), 1500);
	}

	onChoseLocation(event) {
		this.latitude = event.coords.lat;
		this.longitude = event.coords.lng;

		// getting address from lat long
		var latlng = { lat: event.coords.lat, lng: event.coords.lng };
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode({ 'location': latlng }, (results, status) => {
			if (status) {
				if (results[0]) {
					console.log(JSON.stringify(results));
					this.searchElementRef.nativeElement.value = results[0].formatted_address;
					this.locationAddress = results[0].formatted_address;
				} else {
					this.searchElementRef.nativeElement.value = 'No results found';
				}
			} else {
				console.log('Geocoder failed due to: ' + status);
			}
		});

	}

	setSessionTopicList(id) {
		var x = this.sessionTopicService.getAllTopicList(id);

		x.snapshotChanges().subscribe(list => {

			console.log("SessionTopicList", list);
			this.sessionTopicList = new Array();	
			let i = 0;
			list.forEach(element => {
			
				var y = element.payload.toJSON() as SessionTopic;
				y['$key'] = element.key;
				this.sessionTopicList[i] = (y as SessionTopic);

				i++
			});
		});
		console.log(this.sessionTopicList);
	}





	setSpeakerList(id) {
		
		var x = this.speakarService.getSpeakerProfile(id);
		x.snapshotChanges().subscribe(list => {
			if (this.popupWindow !== null) {
				this.popupWindow.close();
			}
			this.speakerList = new Array();
			list.forEach(element => {

				
				var y = element.payload.toJSON();
				y['$key'] = element.key;
				let speakerObject = y as Speaker;
				
				console.log("Speaker", speakerObject);
				this.speakerList.push(speakerObject);
				this.availableSpeakerList.push(speakerObject);

				// if (this.session.speakerList != null && this.session.speakerList.indexOf(element.key) != -1) {
				// 	this.checkBoxSpeaker.push(true);
				// 	this.availableSpeakerList.push({
				// 		key: speakerObject.$key,
				// 		name: speakerObject.name,
				// 		id: `speaker-${speakerObject.$key}`
				// 	});
				// } else {
				// 	this.checkBoxSpeaker.push(false);
				// }
				// if (this.session.chairpersonList != null && this.session.chairpersonList.indexOf(element.key) != -1) {
				// 	this.checkBoxChairPerson.push(true);
				// } else {
				// 	this.checkBoxChairPerson.push(false);
				// }


			});
		});
	}


	


	//To format string for date
	stringToFormatedDateString(str: string): string {
		let formatedDateString = str;
		if (str.length == 17) {
			formatedDateString = str.substring(4, 8) + '-' + str.substring(2, 4) + '-' + str.substring(0, 2) + 'T' + str.substring(9);
		}
		return formatedDateString;
	}

	selectStartDate(event) {
		console.log(event);
		if (this.startTime) {
			if (this.startTime && this.startDate) {
				let timeData: string[] = this.startTime.split(':');
				let h: number = +timeData[0];
				let m: number = +timeData[1];
				this.startDate.setHours(h, m, 0);
				this.startDate = new Date(this.startDate);
			} else if (this.startDate) {
				this.startDate.setHours(0, 0, 0);
				this.startDate = new Date(this.startDate);
			}
		} else {
			this.startDate.setHours(9, 0, 0);
			this.startTime = '9:0';
			this.startDate = new Date(this.startDate);
		}
	}

	selectEndDate() {
		console.log(this.endDate);
		if (this.endTime) {
			if (this.endTime && this.endDate) {
				let timeData: string[] = this.endTime.split(':');
				let h: number = +timeData[0];
				let m: number = +timeData[1];
				this.endDate.setHours(h, m, 0);
				this.endDate = new Date(this.endDate);
			} else if (this.endDate) {
				this.endDate.setHours(0, 0, 0);
				this.endDate = new Date(this.endDate);
			}
		} else {
			this.endDate.setHours(9, 0, 0);
			this.endTime = '9:0';
			this.endDate = new Date(this.endDate);
		}
	}

	changeStartTime(event: string) {
		if (event && this.startDate) {
			this.startTime = event;
			let timeData: string[] = event.split(':');
			let h: number = +timeData[0];
			let m: number = +timeData[1];
			this.startDate.setHours(h, m, 0);
			this.startDate = new Date(this.startDate);
		} else if (this.startDate) {
			this.startDate.setHours(9, 0, 0);
			this.startTime = '9:0';
			this.startDate = new Date(this.startDate);
		}
	}

	changeEndTime(event: string) {
		if (event && this.endDate) {
			this.endTime = event;
			let timeData: string[] = event.split(':');
			let h: number = +timeData[0];
			let m: number = +timeData[1];
			this.endDate.setHours(h, m, 0);
			this.endDate = new Date(this.endDate);
		} else if (this.endDate) {
			this.endDate.setHours(9, 0, 0);
			this.endTime = '9:0';
			this.endDate = new Date(this.endDate);
		}
	}

	AddRemoveTopicSpeaker(topic_index, speaker) {

	}

	


	// submit() {
	// 	// this.validate();
	// 	if (this.session.hasDifferentVenue) {
	// 		this.session.locationAddress = this.locationAddress;
	// 		this.session.latitude = this.lat;
	// 		this.session.longitude = this.long;
	// 		//this.session.locationShort = this.locationShort;
	// 	} else {
	// 		this.session.locationAddress = " ";
	// 		//this.session.locationShort = " ";
	// 		// try {
	// 		// 	delete this.session.locationAddress;
	// 		// 	delete this.session.locationShort;
	// 		// } catch (e) {
	// 		// 	console.error(e);
	// 		// }
	// 	}

	// 	console.log("SESSION_TOPICS", this.sessionTopics);
	// 	if (this.validate()) {

	// 		this.showVenueTab = this.session.showVenueTab;

	// 		if (!this.session.isTimeNotKnown) {
	// 			this.session.startTime = this.datepipe.transform(this.startDate, Constants.DATE_TIME_FORMAT);
	// 			this.session.endTime = this.datepipe.transform(this.endDate, Constants.DATE_TIME_FORMAT);

	// 			//this.session.sessionTopics = this.sessionTopics;

	// 		}



	// 		if (this.sessionId == null) {
	// 			this.add();

	// 		} else {
	// 			this.update();
	// 			this.sessionTopics.forEach(topic => {

	// 				this.sessionTopicService.addSessionTopicDetails(topic, this.eventId);

	// 			})
	// 		}
	// 	} else {
	// 		this.isError = true;
	// 	}

	// }

	validate() {
		this.isError = false;
		this.errorMessage = new Array();
		let valid = true;
		this.setDefaultClasses();

		// this.sessionTopi.aboutList.forEach(element => {
		// 	if (element.type == 'text' && (element.text == null || element.text.trim().length < 1)) {
		// 		if (this.errorMessage.indexOf('Text cannot empty') == -1) {
		// 			this.errorMessage.push('Text cannot empty');
		// 		}
		// 		valid = false;
		// 	}
		// 	if (element.type == 'url' && (element.url == null || element.url.trim().length < 1)) {
		// 		if (this.errorMessage.indexOf('Url cannot empty') == -1) {
		// 			this.errorMessage.push('Url cannot empty');
		// 		}
		// 		valid = false;
		// 	}
		// 	if (element.type == 'youtubeVideo' && (element.url == null || element.url.trim().length < 1)) {
		// 		if (this.errorMessage.indexOf('Youtube url cannot empty') == -1) {
		// 			this.errorMessage.push('Youtube url cannot empty');
		// 		}
		// 		valid = false;
		// 	}
		// 	if (element.type == 'cards') {
		// 		element.listItems.forEach(item => {
		// 			if (item == null || item.trim().length < 1) {
		// 				if (this.errorMessage.indexOf('Card text cannot empty') == -1) {
		// 					this.errorMessage.push('Card text cannot empty');
		// 				}
		// 				valid = false;
		// 			}
		// 		});
		// 	}
		// 	if (element.type == 'image' && element.contentMandatoryList.length < 1) {
		// 		if (this.errorMessage.indexOf('please browse an image') == -1) {
		// 			this.errorMessage.push('please browse an image');
		// 		}
		// 		valid = false;
		// 	}
		// 	if (element.type == 'video' && element.contentMandatoryList.length < 1) {
		// 		if (this.errorMessage.indexOf('please browse an video') == -1) {
		// 			this.errorMessage.push('please browse an video');
		// 		}
		// 		valid = false;
		// 	}
		// 	if (element.type == 'list' && (element.listWithinListList == null || element.listWithinListList.length < 1)) {
		// 		if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
		// 			this.errorMessage.push('Add atleast one list item');
		// 		}
		// 		valid = false;
		// 	} else if (element.type == 'list' && element.listWithinListList.length == 1 && element.listWithinListList[0].hasSubList == null) {
		// 		if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
		// 			this.errorMessage.push('Add atleast one list item');
		// 		}
		// 		valid = false;
		// 	} else if (element.type == 'list' && element.listWithinListList != null && element.listWithinListList.length > 0) {
		// 		element.listWithinListList.forEach(subList => {
		// 			let bool = this.validateList(subList);
		// 			if (!bool) {
		// 				valid = false;
		// 			}
		// 		});
		// 	}
		// 	if (element.type == null || element.type.trim().length < 1) {
		// 		this.remove(this.session.aboutList.indexOf(element));
		// 	}

		// });

		
		return valid;
	}

	validateList(listWithinList: ListWithinList): boolean {
		let valid = true;
		if ((listWithinList.hasSubList != null && (listWithinList.text == null || listWithinList.text.length < 1))) {
			if (this.errorMessage.indexOf('list field cannot empty') == -1) {
				this.errorMessage.push('list field cannot empty');
			}
			valid = false;
		}
		if (listWithinList.hasSubList && listWithinList.listWithinListList != null && listWithinList.listWithinListList.length > 0) {
			listWithinList.listWithinListList.forEach(subList => {
				valid = this.validateList(subList);
			});
		}
		return valid;
	}

	dateDiff(date1, date2) {
		var datediff = date1.getTime() - date2.getTime();
		return (datediff / (24 * 60 * 60 * 1000));
	}

	setDefaultClasses() {
		this.nameClass = 'form-control';
		this.startTimeClass = 'dateIcon';
		this.endTimeClass = 'dateIcon';
		this.locationClass = 'form-control';
		this.descClass = 'form-control';
	}

	addNewSpeaker() {
		let windowW = screen.width * 0.8;
		let windowH = screen.height * 0.9;
		let LeftPosition = (screen.width) ? (screen.width - windowW) / 2 : 0;
		let TopPosition = (screen.height) ? (screen.height - windowH) / 2 : 0;
		let settings = 'height=' + windowH + ',width=' + windowW + ',top=' + TopPosition + ',left=' + LeftPosition + ',scrollbars=yes,resizable'
		this.popupWindow = window.open('http://' + window.location.host + '/event/speaker-profile?eventId=' + this.eventId, 'New Speaker', settings);
	}

	// add() {
	// 	this.disableButton = false;
	// 	this.session.position = this.sessionList.length;
	// 	let sessionDetails = this.session;

	// 	let sessionKey = this.sessionService.addSessionDetails(sessionDetails, this.eventId);
	// 	this.sessionTopics.forEach(topic => {

	// 		topic['sessionId'] = sessionKey;
	// 		this.sessionTopicService.addSessionTopicDetails(topic, this.eventId);

	// 	});
	// 	// this.sessionTopics.forEach(topics => {

	// 	// 	delete topics.$key;
	// 	// 	this.sessionTopicService.addSessionTopicDetails(topics, this.eventId);

	// 	// });

	// 	if (sessionKey) {
	// 		this.message = 'Added Successfully';
	// 		setTimeout(function () {
	// 			this.message = null;
	// 			this.disableButton = true;
	// 			this.router.navigate([Constants.SESSION_FORM, this.eventId]);
	// 		}.bind(this), 2000);
	// 	}
	// 	this.removeSlider();
	// }

	// update() {
	// 	this.disableButton = false;
	// 	let sessionDetails = this.session;
	// 	this.sessionService.updateSessionDetails(sessionDetails, this.eventId, this.sessionId).then(res => {
	// 		this.message = 'Updated Successfully';
	// 	}).catch(error => {
	// 		this.disableButton = true;
	// 		this.errorMessage = error.message;
	// 	});
	// 	setTimeout(function () {
	// 		this.message = null;
	// 		this.disableButton = true;
	// 		this.router.navigate([Constants.SESSION_FORM, this.eventId]);
	// 	}.bind(this), 2000);
	// 	this.removeSlider();
	// }

	deleteTopic(topicKey: string, index: number){

		console.log("Deleting Topic", topicKey)
		if(confirm("Do you really want to delete this topic? Topic will be deleted Instantly")){
			let that = this;
			this.sessionTopicService.deleteSessionTopicById(topicKey, this.eventId).then(d=>{
				that.sessionTopics.splice(index, 1);
			});
		}
		
	}


}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/session-topic/sessions-topic.component.ts